/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Empty_Cta_Open_Viewing_TasksInputs */

const cs_templates_empty_cta_open_viewing_tasks = /** @type {(inputs: Templates_Empty_Cta_Open_Viewing_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít úkoly prohlídek`)
};

const en_templates_empty_cta_open_viewing_tasks = /** @type {(inputs: Templates_Empty_Cta_Open_Viewing_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open viewing tasks`)
};

/**
* | output |
* | --- |
* | "Open viewing tasks" |
*
* @param {Templates_Empty_Cta_Open_Viewing_TasksInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_empty_cta_open_viewing_tasks = /** @type {((inputs?: Templates_Empty_Cta_Open_Viewing_TasksInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Empty_Cta_Open_Viewing_TasksInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_empty_cta_open_viewing_tasks(inputs)
	return cs_templates_empty_cta_open_viewing_tasks(inputs)
});